<template>
    <v-dialog v-model="mostrar" max-width="290" fullscreen>
        <v-card :loading="loading">
            <v-toolbar color="blue-grey darken-2" dark>
                <v-toolbar-title>Generar Transferencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="$emit('getArchivoTransferencia')">
                    descargar
                </v-btn>
            </v-toolbar>

        <v-container text-center>
          <v-row wrap>

            <v-col md="6"> <!-- Campos a llenar -->
                <v-row md="12"><!-- Fecha actual -->
                    <v-col md="12">
                        Fecha actual:
                    </v-col>
                    <v-col md="6">
                    <v-menu
                        ref="menu"
                        v-model="horasLetraPicker"
                        :close-on-content-click="false"
                        :return-value.sync="horasLetra"
                        max-width="1px"
                        min-width="1px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="horasLetra"
                            label="Hora actual"                   
                            type="time"
                            v-on="on"
                            @change="$refs.menu.save(horasLetra)"
                            
                        ></v-text-field>
                        </template>
                    </v-menu>
                    </v-col>
                    <v-col md="6">
                        <v-menu
                            v-model="diamesAnioLetraPicker"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="diamesAnioLetraTexto"
                                :outlined="outlined"
                                label="Fecha actual:"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="diamesAnioLetra"
                                locale="es"
                                @change="diamesAnioLetraPicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                
                <v-row md="12"><!-- Secretaría General -->
                    <v-col md="12">
                        Secretaría General:
                    </v-col>
                    <v-col md="2">
                        <v-select 
                            v-model="GeneroResponsableArchivo"
                            :items="generos"
                            item-value="nombre"
                            item-text="nombre"
                            label="Género:"
                            :outlined="outlined"
                        />
                    </v-col>
                    <v-col md="6">
                        <v-text-field
                        label="Nombre responsable del archivo de trámite"
                        v-model="responsableArchivo"
                        :outlined="outlined"
                        :error-messages="responsableArchivoErrors"
                        @input="$v.responsableArchivo.$touch()"
                        @blur="$v.responsableArchivo.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Cargo que ocupa"
                        v-model="cargoResponsableArchivo"
                        :outlined="outlined"
                        :error-messages="cargoResponsableArchivoErrors"
                        @input="$v.cargoResponsableArchivo.$touch()"
                        @blur="$v.cargoResponsableArchivo.$touch()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <v-row md="12"><!-- Coordinación de Transparencia -->
                    <v-col md="12">
                        Coordinación de Transparencia y Archivo General:
                    </v-col>
                    <v-col md="2">
                        <v-select 
                            v-model="GeneroTransp"
                            :items="generos"
                            item-value="nombre"
                            item-text="nombre"
                            label="Género:"
                            :outlined="outlined"
                        />
                    </v-col>
                    <v-col md="6">
                        <v-text-field
                        label="Nombre"
                        v-model="responsableTransparencia"
                        :outlined="outlined"
                        :error-messages="responsableTransparenciaErrors"
                        @input="$v.responsableTransparencia.$touch()"
                        @blur="$v.responsableTransparencia.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Cargo que ocupa"
                        v-model="cargoTransparencia"
                        :outlined="outlined"
                        :error-messages="cargoTransparenciaErrors"
                        @input="$v.cargoTransparencia.$touch()"
                        @blur="$v.cargoTransparencia.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="5">
                        <v-text-field
                        label="No. oficio por el que fue designado"
                        v-model="oficio"
                        :outlined="outlined"
                        :error-messages="oficioErrors"
                        @input="$v.oficio.$touch()"
                        @blur="$v.oficio.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-menu
                            v-model="fechaOficioLetraPicker"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="fechaOficioLetraTexto"
                                :outlined="outlined"
                                label="Fecha oficio:"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fechaOficioLetra"
                                locale="es"
                                @change="fechaOficioLetraPicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                
                <v-row md="12"><!-- Contraloría General -->
                    <v-col md="12">
                        Contraloría General:
                    </v-col>
                    <v-col md="2">
                        <v-select 
                            v-model="GeneroContr"
                            :items="generos"
                            item-value="nombre"
                            item-text="nombre"
                            label="Género:"
                            :outlined="outlined"
                        />
                    </v-col>
                    <v-col md="6">
                        <v-text-field
                        label="Nombre"
                        v-model="responsableContraloria"
                        :outlined="outlined"
                        :error-messages="responsableContraloriaErrors"
                        @input="$v.responsableContraloria.$touch()"
                        @blur="$v.responsableContraloria.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Cargo que ocupa"
                        v-model="cargoContraloria"
                        :outlined="outlined"
                        :error-messages="cargoContraloriaErrors"
                        @input="$v.cargoContraloria.$touch()"
                        @blur="$v.cargoContraloria.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="5">
                        <v-text-field
                        label="No. oficio por el que fue designado"
                        v-model="oficioContraloria"
                        :outlined="outlined"
                        :error-messages="oficioContraloriaErrors"
                        @input="$v.oficioContraloria.$touch()"
                        @blur="$v.oficioContraloria.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-menu
                            v-model="fechaOficioContraloriaLetraPicker"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="fechaOficioContraloriaLetraTexto"
                                :outlined="outlined"
                                label="Fecha oficio:"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fechaOficioContraloriaLetra"
                                locale="es"
                                @change="fechaOficioContraloriaLetraPicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

                <v-row md="12"><!-- Testigos de asistencia -->
                    <v-col md="12">
                        Testigos de asistencia:
                    </v-col>
                    <!-- Testigo 1 -->
                    <v-col md="2">
                        Testigo 1:
                    </v-col>
                    <v-col md="2">
                        <v-select 
                            v-model="GeneroTestigo1"
                            :items="generos"
                            item-value="nombre"
                            item-text="nombre"
                            label="Género:"
                            :outlined="outlined"
                        />
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Nombre"
                        v-model="testigo"
                        :outlined="outlined"
                        :error-messages="testigoErrors"
                        @input="$v.testigo.$touch()"
                        @blur="$v.testigo.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Cargo que ocupa"
                        v-model="cargoTestigo"
                        :outlined="outlined"
                        :error-messages="cargoTestigoErrors"
                        @input="$v.cargoTestigo.$touch()"
                        @blur="$v.cargoTestigo.$touch()"
                        ></v-text-field>
                    </v-col>
                    <!-- Testigo 2 -->
                    <v-col md="2">
                        Testigo 2:
                    </v-col>
                    <v-col md="2">
                        <v-select 
                            v-model="GeneroTestigo2"
                            :items="generos"
                            item-value="nombre"
                            item-text="nombre"
                            label="Género:"
                            :outlined="outlined"
                        />
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Nombre"
                        v-model="testigoll"
                        :outlined="outlined"
                        :error-messages="testigollErrors"
                        @input="$v.testigoll.$touch()"
                        @blur="$v.testigoll.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="4">
                        <v-text-field
                        label="Cargo que ocupa"
                        v-model="cargoll"
                        :outlined="outlined"
                        :error-messages="cargollErrors"
                        @input="$v.cargoll.$touch()"
                        @blur="$v.cargoll.$touch()"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- ANTECEDENTES -->
                <v-row md="12"><!-- Parte 1 -->
                    <v-col md="12">
                        ANTECEDENTES
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="No. oficio"
                        v-model="nooficio"
                        :outlined="outlined"
                        :error-messages="nooficioErrors"
                        @input="$v.nooficio.$touch()"
                        @blur="$v.nooficio.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-menu
                            v-model="fechanooficioPicker"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="fechanooficioTexto"
                                :outlined="outlined"
                                label="Fecha oficio:"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fechanooficio"
                                locale="es"
                                @change="fechanooficioPicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="No. legajos"
                        v-model="legajos"
                        :outlined="outlined"
                        :error-messages="legajosErrors"
                        @input="$v.legajos.$touch()"
                        @blur="$v.legajos.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="No. cajas"
                        v-model="cajas"
                        :outlined="outlined"
                        :error-messages="cajasErrors"
                        @input="$v.cajas.$touch()"
                        @blur="$v.cajas.$touch()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                
                <v-row md="12"><!-- Responsable de Archivo -->
                    <v-col md="5">
                        Responsable de Archivo de Trámite de la Oficina de la Secretaría General convocó mediante
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="No. oficio"
                        v-model="oficiocajas"
                        :outlined="outlined"
                        :error-messages="oficiocajasErrors"
                        @input="$v.oficiocajas.$touch()"
                        @blur="$v.oficiocajas.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-menu
                            v-model="fechaoficiocajasPicker"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="fechaoficiocajasTexto"
                                :outlined="outlined"
                                label="Fecha oficio:"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fechaoficiocajas"
                                locale="es"
                                @change="fechaoficiocajasPicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                
                <v-row md="12"><!-- HECHOS -->
                    <v-col md="12">
                        HECHOS
                    </v-col>
                    <v-col md="12">
                        <v-textarea
                        v-model="descripcion"
                        label="Descripción de la Documentación"
                        ></v-textarea>
                    </v-col>
                    <v-col md="5">
                        <v-text-field
                        label="Área Productora de la Documentación"
                        v-model="areaProductora"
                        :outlined="outlined"
                        :error-messages="areaProductoraErrors"
                        @input="$v.areaProductora.$touch()"
                        @blur="$v.areaProductora.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="No. de cajas"
                        v-model="noCajas"
                        :outlined="outlined"
                        :error-messages="noCajasErrors"
                        @input="$v.noCajas.$touch()"
                        @blur="$v.noCajas.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="No. documentos"
                        v-model="noDocumentos"
                        :outlined="outlined"
                        :error-messages="noDocumentosErrors"
                        @input="$v.noDocumentos.$touch()"
                        @blur="$v.noDocumentos.$touch()"
                        ></v-text-field>
                    </v-col>
                    
                    <v-col md="3">
                        <v-menu
                            v-model="fechasExtremasPicker"
                            :close-on-content-click="false"
                            max-width="290"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :value="fechasExtremasTexto"
                                :outlined="outlined"
                                label="Fechas extremas:"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="fechasExtremas"
                                locale="es"
                                @change="fechasExtremasPicker = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="Total de kilogramos"
                        v-model="noKilos"
                        :outlined="outlined"
                        :error-messages="noKilosErrors"
                        @input="$v.noKilos.$touch()"
                        @blur="$v.noKilos.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                        label="Total de metros lineales"
                        v-model="noMetros"
                        :outlined="outlined"
                        :error-messages="asuntoErrors"
                        @input="$v.noMetros.$touch()"
                        @blur="$v.noMetros.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-menu
                            ref="menu"
                            v-model="horasconletraPicker"
                            :close-on-content-click="false"
                            :return-value.sync="horasconletra"
                            max-width="1px"
                            min-width="1px"
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="horasconletra"
                                label="Hora de fin de actuación"                   
                                type="time"
                                v-on="on"
                                @change="$refs.menu.save(horasconletra)"
                                
                            ></v-text-field>
                            </template>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-col>

            <v-col md="6"> <!-- Previsualización -->
                <previsualizar v-if="previsualizar">
                
                    <v-col md="12" v-html="verTexto(0,0)">
                    </v-col>
                    <v-col md="12" v-html="verTexto(0,1)">
                    </v-col>
                    <v-col md="12">
                        {{verTexto(0,2)}}
                    </v-col>
                    <v-col md="12">
                        {{verTexto(0,3)}}
                    </v-col>
                    <v-col md="12">
                        {{verTexto(0,4)}}
                    </v-col>

                    <v-col md="12">
                        {{verTexto(1,"no")}}
                    </v-col>
                    <v-col md="12">
                        {{verTexto(2,"no")}}
                    </v-col>
                    <v-col md="12">
                        {{verTexto(3,"no")}}
                    </v-col>
                    <v-col md="12">
                        {{verTexto(4,"no")}}
                    </v-col>
                    
                    <v-ul>
                        <v-col md="12">
                            {{verTexto(5,0)}}
                        </v-col>
                        <v-col md="12">
                            {{verTexto(5,1)}}
                        </v-col>
                        <v-col md="12">
                            {{verTexto(5,2)}}
                        </v-col>
                        <v-col md="12">
                            {{verTexto(5,3)}}
                        </v-col>
                        <v-col md="12">
                            {{verTexto(5,4)}}
                        </v-col>
                        <v-col md="12">
                            {{verTexto(5,5)}}
                        </v-col>
                        <v-col md="12">
                            {{verTexto(5,6)}}
                        </v-col>
                    </v-ul>
                    
                    <v-col md="12">
                        {{verTexto(6,"no")}}
                    </v-col>
                    <v-btn color="blue-grey darken-1" @click="cerrarAmbasVentanas()">Cerrar Previsualización</v-btn>
                    
                </previsualizar>
            </v-col>

          </v-row>
        </v-container>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="blue-grey darken-1" outlined :disabled="loading" text @click="$emit('cancelar')">Cancelar</v-btn>
            <!-- <v-btn color="blue-grey darken-1" dark :loading="loading" @click="guardarOficio()">Guardar</v-btn> -->
            <v-btn color="blue-grey darken-1" @click="nuevaVentana()">Previsualizar</v-btn>
        </v-card-actions>


      </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import buscarEmisorEntidadComponent from "../widgets/buscarEmisorEntidad.vue";
import {Settings,DateTime} from 'luxon';
import axios from "axios";

Settings.defaultLocale = 'es';

export default {
    name: 'Formulario',
    props:['mostrar','relacionado','ultimaEntidad'],
    mixins: [validationMixin],
    computed: {
        ...mapGetters([
            "httpURL", 
            "sessionToken",
            "userId"
        ]),
        numeroErrors() {
            const errors = [];
            if (!this.$v.numero.$dirty) return errors;
            !this.$v.numero.required && errors.push("Campo requerido.");
            return errors;
        },
        responsableArchivoErrors() {
            const errors = [];
            if (!this.$v.responsableArchivo.$dirty) return errors;
            !this.$v.responsableArchivo.required && errors.push("Campo requerido.");
            return errors;
        },
        cargoResponsableArchivoErrors() {
            const errors = [];
            if (!this.$v.cargoResponsableArchivo.$dirty) return errors;
            !this.$v.cargoResponsableArchivo.required && errors.push("Campo requerido.");
            return errors;
        },
        responsableTransparenciaErrors() {
            const errors = [];
            if (!this.$v.responsableTransparencia.$dirty) return errors;
            !this.$v.responsableTransparencia.required && errors.push("Campo requerido.");
            return errors;
        },
        cargoTransparenciaErrors() {
            const errors = [];
            if (!this.$v.cargoTransparencia.$dirty) return errors;
            !this.$v.cargoTransparencia.required && errors.push("Campo requerido.");
            return errors;
        },
        oficioErrors() {
            const errors = [];
            if (!this.$v.oficio.$dirty) return errors;
            !this.$v.oficio.required && errors.push("Campo requerido.");
            return errors;
        },
        responsableContraloriaErrors() {
            const errors = [];
            if (!this.$v.responsableContraloria.$dirty) return errors;
            !this.$v.responsableContraloria.required && errors.push("Campo requerido.");
            return errors;
        },
        cargoContraloriaErrors() {
            const errors = [];
            if (!this.$v.cargoContraloria.$dirty) return errors;
            !this.$v.cargoContraloria.required && errors.push("Campo requerido.");
            return errors;
        },
        oficioContraloriaErrors() {
            const errors = [];
            if (!this.$v.oficioContraloria.$dirty) return errors;
            !this.$v.oficioContraloria.required && errors.push("Campo requerido.");
            return errors;
        },
        testigoErrors() {
            const errors = [];
            if (!this.$v.testigo.$dirty) return errors;
            !this.$v.testigo.required && errors.push("Campo requerido.");
            return errors;
        },
        cargoTestigoErrors() {
            const errors = [];
            if (!this.$v.cargoTestigo.$dirty) return errors;
            !this.$v.cargoTestigo.required && errors.push("Campo requerido.");
            return errors;
        },
        testigollErrors() {
            const errors = [];
            if (!this.$v.testigoll.$dirty) return errors;
            !this.$v.testigoll.required && errors.push("Campo requerido.");
            return errors;
        },
        cargollErrors() {
            const errors = [];
            if (!this.$v.cargoll.$dirty) return errors;
            !this.$v.cargoll.required && errors.push("Campo requerido.");
            return errors;
        },
        nooficioErrors() {
            const errors = [];
            if (!this.$v.nooficio.$dirty) return errors;
            !this.$v.nooficio.required && errors.push("Campo requerido.");
            return errors;
        },
        legajosErrors() {
            const errors = [];
            if (!this.$v.legajos.$dirty) return errors;
            if (!this.$v.legajos.required) {
                errors.push("Campo requerido.");
            } else if (this.$v.legajos.value <= 0) {
                errors.push("El número debe ser mayor a 0.");
            }
            return errors;
        },
        cajasErrors() {
            const errors = [];
            if (!this.$v.cajas.$dirty) return errors;
            !this.$v.cajas.required && errors.push("Campo requerido.");
            return errors;
        },
        areaProductoraErrors() {
            const errors = [];
            if (!this.$v.areaProductora.$dirty) return errors;
            !this.$v.areaProductora.required && errors.push("Campo requerido.");
            return errors;
        },
        noCajasErrors() {
            const errors = [];
            if (!this.$v.noCajas.$dirty) return errors;
            !this.$v.noCajas.required && errors.push("Campo requerido.");
            return errors;
        },
        noDocumentosErrors() {
            const errors = [];
            if (!this.$v.noDocumentos.$dirty) return errors;
            !this.$v.noDocumentos.required && errors.push("Campo requerido.");
            return errors;
        },
        noKilosErrors() {
            const errors = [];
            if (!this.$v.noKilos.$dirty) return errors;
            !this.$v.noKilos.required && errors.push("Campo requerido.");
            return errors;
        },
        noMetrosErrors() {
            const errors = [];
            if (!this.$v.noMetros.$dirty) return errors;
            !this.$v.noMetros.required && errors.push("Campo requerido.");
            return errors;
        },
        fechaTexto(){
            return this.fecha ? DateTime.fromFormat(this.fecha, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        documentosErrors() {
            const errors = [];
            if (!this.$v.documentos.$dirty) return errors;
            !this.$v.documentos.required && errors.push("Campo requerido.");
            !this.$v.documentos.decimal && errors.push("Debe ingresar un número");
            return errors;
        },
        diamesAnioLetraTexto(){
            return this.diamesAnioLetra ? DateTime.fromFormat(this.diamesAnioLetra, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        fechaOficioLetraTexto(){
            return this.fechaOficioLetra ? DateTime.fromFormat(this.fechaOficioLetra, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        fechaOficioContraloriaLetraTexto(){
            return this.fechaOficioContraloriaLetra ? DateTime.fromFormat(this.fechaOficioContraloriaLetra, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        fechanooficioTexto(){
            return this.fechanooficio ? DateTime.fromFormat(this.fechanooficio, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        fechaoficiocajasTexto(){
            return this.fechaoficiocajas ? DateTime.fromFormat(this.fechaoficiocajas, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        fechasExtremasTexto(){
            return this.fechasExtremas ? DateTime.fromFormat(this.fechasExtremas, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
        },
        recepcion(){
            return this.diamesAnioLetra+' '+this.horasLetra+':00';
        },

    },
    validations:{
        numero: {required},
        responsableArchivo: {required},
        cargoResponsableArchivo: {required},
        responsableTransparencia: {required},
        cargoTransparencia: {required},
        oficio: {required},
        responsableContraloria: {required},
        cargoContraloria: {required},
        oficioContraloria: {required},
        testigo: {required},
        cargoTestigo: {required},
        testigoll: {required},
        cargoll: {required},
        nooficio: {required},
        legajos: {required},
        cajas: {required},
        oficiocajas: {required},
        areaProductora: {required},
        noCajas: {required},
        noDocumentos: {required},
        noKilos: {required},
        noMetros: {required},
        
        emisorResponsable: {required },
        emisorCargo: {required },
        destinatarioCargo: {required },
        documentos: {required, decimal }
    },
    components: {
      buscarEmisorEntidadComponent,
    },
    data: () => ({
        loading: false,
        outlined: false,
        guardado: false,
        generos: ["Masculino","Femenino"],
        horasLetra: DateTime.now().setZone('America/Mazatlan').toFormat("T"),
        horasLetraPicker: false,
        diamesAnioLetra: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        diamesAnioLetraPicker: false,
        GeneroResponsableArchivo: "Masculino",
        responsableArchivo: null,
        cargoResponsableArchivo: null,
        oficio: null,
        GeneroTransp: "Masculino",
        responsableTransparencia: null,
        cargoTransparencia: null,
        fechaOficioLetra: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechaOficioLetraPicker: false,
        GeneroContr: "Masculino",
        responsableContraloria: null,
        cargoContraloria: null,
        oficioContraloria: null,
        fechaOficioContraloriaLetra: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechaOficioContraloriaLetraPicker: false,
        GeneroTestigo1: "Masculino",
        testigo: null,
        cargoTestigo: null,
        GeneroTestigo2: "Masculino",
        testigoll: null,
        cargoll: null,
        nooficio: null,
        fechanooficio: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechanooficioPicker: false,
        legajos: 0,
        cajas: 0,
        oficiocajas: null,
        fechaoficiocajas: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechaoficiocajasPicker: false,
        descripcion: null,
        areaProductora: null,
        noCajas: 0,
        noDocumentos: 0,
        fechasExtremas: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
        fechasExtremasPicker:false,
        noKilos: 0,
        noMetros: 0,
        horasconletra: DateTime.now().setZone('America/Mazatlan').toFormat("T"),
        horasconletraPicker: false,
        historico: [],
        previsualizar: false,
        campos: 12,
        previsualizacion: 0,
    }),
    watch:{
        requiereRespuesta(nueva){
            if( !nueva )
                this.fechaRespuesta = null;
        },
    },
   
    methods:{
        getTexto()
        {
            let _generoResponsableArchivo = "el"
            let _generoTestigo1 = "el"
            let _generoTestigo2 = "el"
            let _generoTransp = "el"
            let _generoContr = "el"
            let _letraTransp = "o"
            let _letraContr = "o"
            let _letraTestigos = "o"

            if (this.GeneroTestigo1 === "Femenino") {
                _generoTestigo1 = "la";
            }
            if (this.GeneroTestigo2 === "Femenino") {
                _generoTestigo2 = "la";
            }
            if (this.GeneroTestigo1 === "Femenino" && this.GeneroTestigo2 === "Femenino") {
                _letraTestigos = "a";
            }
            
            if (this.GeneroResponsableArchivo === "Femenino") {
                _generoResponsableArchivo = "la";
            }
            if (this.GeneroTransp === "Femenino") {
                _generoTransp = "la";
                _letraTransp = "a"
            }
            if (this.GeneroContr === "Femenino") {
                _generoContr = "la";
                _letraContr = "a"
            }
            let primeraParte = [
            `Acta Administrativa que se formula para la eliminación de los Documentos de Comprobación Administrativa Inmediata, generados en la Secretaría General con motivo del ejercicio de sus funciones, documentos que ya cumplieron con su utilidad. En la Ciudad de Guadalajara, siendo las <span class="subrayado-amarillo">${this.horasLetra}</span> horas del dia <span class="subrayado-amarillo">${this.diamesAnioLetraTexto}</span>, se reunieron en la Oficina de la Secretaria General localizada en Avenida Juárez No. 976, Edificio de la Rectoría General, Piso 5, Colonia Centro C.P. 44100, Guadalajara, Jalisco. México, los C.C.:  _________________________________________________________________________________________`,
            `Por la Secretaria General, ${_generoResponsableArchivo} ${this.responsableArchivo} ${this.cargoResponsableArchivo}.`,
            `Por la Coordinación de Transparencia y Archivo General, ${_generoTransp} ${this.responsableTransparencia} ${this.cargoTransparencia}, designad${_letraTransp} por el Coordinador de Transparencia y Archivo General, mediante oficio No. ${this.oficio} de fecha ${this.fechaOficioLetraTexto}.`,
            `Por la Contraloría General, ${_generoContr} ${this.responsableContraloria} ${this.cargoContraloria}, designad${_letraContr} por el Contralor General, mediante oficio No. ${this.oficioContraloria} de fecha ${this.fechaOficioContraloriaLetraTexto}.`,
            `Intervienen como testigos de asistencia ${_generoTestigo1} C. ${this.testigo} quien ocupa el cargo de ${this.cargoTestigo} y ${_generoTestigo2} C. ${this.testigoll} quien ocupa el cargo de ${this.cargoll} amb${_letraTestigos}s adscrit${_letraTestigos}s a la Oficina de la Secretaria General.`
            ]
            let segundaParte = `ANTECEDENTES`
            let terceraParte = `Conforme a los Criterios para la organización de los archivos de la Universidad de Guadalajara (al ACUERDO del Consejo Nacional del Sistema Nacional de Trauparencia, Acceso a la Información Pública y Protección de Datos Personales, por el que se aprueban los Lineamientos para la Organización y Conservación de los Archivos), la Oficina de la Secretaría General procedió a la depuración anual de archivos, por lo que mediante oficio número ${this.nooficio}, de fecha ${this.fechanooficioTexto} informó a la Coordinación de Transparencia y Archivo General que previa revisión, depuración y expurgo de los legajos generados en distintas área adscritas a esta Secretaria, por ejercicio de las funciones inherentes a las mismas. Se determinó que ${this.legajos} legajos, contenidos en ${this.cajas} cajas, resultaron como documentos de comprobación administrativa inmediata, conforme al listado del Catálogo de Disposición Documental, por lo que se elaboró la relación simple de dichos documentos, y previa revisión, autorización y formalización por parte del titular del área generadora de la documentación, se envió adjunta al oficio mencionado. Posteriormente, el Responsable de Archivo de Trámite de la Oficina de la Secretaría General, mediante oficio No. ${this.oficiocajas} de fecha ${this.fechaoficiocajasTexto} convocó a la Coordinación de Transparencia y Archivo General y a la Contraloría General, para proceder al levantamiento de la presente Acta Administrativa.`
            let cuartaParte = `HECHOS`
            let quintaParte = `En cumplimiento con los Lineamientos para analizar, valorar y decidir el destino final de la documentación de las dependencias y entidades de la Universidad de Guadalajara, se procede al levantamiento de la presente acta administrativa, por lo que los participantes realizan la revisión y conteo de los documentos para confirmar que se trate de la información manifestada por la Oficina de la Secretaría General, y como resultado se da testimonio de la siguiente información:`
            let sextaParte = [
            `Área Productora de la Documentación: ${this.areaProductora}`,
            `Número de cajas: ${this.noCajas}`,
            `Cantidad de documentos: ${this.noDocumentos}`,
            `Descripción de la Documentación: ${this.descripcion}`,
            `Fechas Extremas: ${this.fechasExtremasTexto}`,
            `Total de kilogramos: ${this.noKilos}`,
            `Total de metros lineales: ${this.noMetros}`
            ]
            let septimaParte = `Por lo anterior se confirma que se trata de la misma documentación manifestada por la Oficina de la Secretaría General en la relación simple que se adjunta, no se detectaron expedientes o series con valor histórico, por lo que se procede a cerrar las cajas de manera definitiva y, ya que se trata de documentos de comprobación administrativa inmediata y que se concluyó su vigencia documental no mayor a un año, conforme al Catalogo Disposición Documental, y que dichos documentos no se transfieren al Archivo de Concentración o Histórico, se procede a eliminar los documentos señalados. No habiendo más hechos que hacer constar se da por terminada la presente actuación a las ${this.horasconletra} horas del mismo día de su inicio, y una vez leída por las partes que en ella intervinieron, la ratifica, firmando al calce para su debida constancia.`

            return [primeraParte,segundaParte,terceraParte,cuartaParte,quintaParte,sextaParte,septimaParte]
        },
        verTexto(parte, subparte){
            let texto = this.getTexto()
            if (subparte != "no") {
                return texto[parte][subparte]
            } else {
                return texto[parte]
            }

        },
        nuevaVentana() {
            // console.log(this.campos,this.previsualizacion)
            this.previsualizar = true
            this.campos = 6
            this.previsualizacion = 6
            // console.log(this.campos,this.previsualizacion)
            
        },
        cerrarAmbasVentanas() {
            this.previsualizar = false;
            this.campos = 12;
            this.previsualizacion = 0;
        }
    }
}

</script>

<style scoped>
    .subrayado-amarillo {
        background-color: yellow; /* Color de fondo amarillo */
        text-decoration: underline; /* Subrayado */
        text-decoration-color: yellow; /* Color del subrayado */
    }
</style>